import React from "react";
import styled from "styled-components";

const TableWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const TableHead = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  border: solid 1px rgba(136, 136, 136, 0.1);
  align-self: stretch;
  box-sizing: border-box;
  padding: 8px 0px;
  flex-shrink: 0;
`;

const TableRow = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Cell = styled.div`
  display: flex;
  justify-content: ${(props) => props.align || "flex-start"};
  flex-direction: row;
  align-items: center;
  flex: ${(props) => (props.flex ? "1" : "none")};
  gap: 8px;
  width: ${(props) => props.width || "auto"};
  box-sizing: border-box;
`;

const Text = styled.span`
  color: ${(props) => props.color || "rgb(33, 37, 67)"};
  text-overflow: ellipsis;
  font-size: ${(props) => props.fontSize || "16px"};
  font-family: Montserrat, sans-serif;
  font-weight: ${(props) => props.fontWeight || "500"};
  line-height: 160%;
  text-align: left;
`;

const StatusTag = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  align-self: stretch;
  background: ${(props) => {
    switch (props.status) {
      case "successful":
        return "linear-gradient(-90deg, rgba(18, 124, 78, 0.1), rgba(18, 124, 78, 0.1))";
      case "pending":
        return "linear-gradient(-90deg, rgba(244, 186, 52, 0.1), rgba(244, 186, 52, 0.1))";
      case "unsuccessful":
        return "linear-gradient(-90deg, rgba(240, 70, 63, 0.1), rgba(240, 70, 63, 0.1))";
      default:
        return "transparent";
    }
  }};
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 4px 8px;
  flex-shrink: 0;
`;

const StatusText = styled.span`
  color: ${(props) => {
    switch (props.status) {
      case "successful":
        return "rgb(18, 124, 78)";
      case "pending":
        return "rgb(244, 186, 52)";
      case "unsuccessful":
        return "rgb(240, 70, 63)";
      default:
        return "inherit";
    }
  }};
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const Table = ({ headers, data, columns }) => {
  const renderCell = (column, item) => {
    if (column.type === "status") {
      return (
        <StatusTag status={item[column.key].toLowerCase()}>
          <StatusText status={item[column.key].toLowerCase()}>
            {item[column.key]}
          </StatusText>
        </StatusTag>
      );
    }

    return (
      <Text
        color={column.color}
        fontSize={column.fontSize}
        fontWeight={column.fontWeight}
      >
        {item[column.key]}
      </Text>
    );
  };

  return (
    <TableWrapper>
      <TableHead>
        {headers.map((header, index) => (
          <Cell
            key={index}
            width={header.width}
            flex={header.flex}
            align={header.align}
          >
            <Text color="rgb(100, 116, 139)">{header.label}</Text>
          </Cell>
        ))}
      </TableHead>
      {data.map((item, rowIndex) => (
        <TableRow key={rowIndex}>
          {columns.map((column, colIndex) => (
            <Cell
              key={colIndex}
              width={column.width}
              flex={column.flex}
              align={column.align}
            >
              {renderCell(column, item)}
            </Cell>
          ))}
        </TableRow>
      ))}
    </TableWrapper>
  );
};

export default Table;
